import { NumericEvaluationParameterDto, NumericEvaluationResultDto } from '@/api/generator';

export type LimitKey = 'upWarning' | 'lowWarning' | 'upError' | 'lowError';

export type LimitedValue = { [k in LimitKey]?: number } & {
  value: number;
};

export function getLimitedValue(
  result: NumericEvaluationResultDto,
  evaluation?: NumericEvaluationParameterDto,
): LimitedValue | undefined {
  if (evaluation && result.deviationValue !== undefined) {
    return {
      value: result.deviationValue,
      lowError: evaluation.lowerFailedLimit ?? undefined,
      lowWarning: evaluation.lowerWarningLimit ?? undefined,
      upWarning: evaluation.upperWarningLimit ?? undefined,
      upError: evaluation.upperFailedLimit ?? undefined,
    };
  }
}
